function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M124.083 24.4961C120.749 26.6309 113.864 31.4212 112.995 33.5042C111.754 31.737 107.241 27.8192 99.1257 26.2857",
  stroke: "#4D46FF",
  strokeWidth: 1.17112,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M120.89 20.4604C118.238 23.7679 113.294 30.7038 113.143 33.5268C112.289 30.1381 108.64 23.6029 102.462 23.0319",
  stroke: "#4D46FF",
  strokeWidth: 1.17112,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.404 47.424L125.592 27.0942C119.269 27.2237 114.594 31.1335 112.948 33.7311C108.488 28.7505 101.101 28.2112 97.8658 29.223C97.8658 29.223 88.3069 51.5253 88.5 51.5C99.6826 50.0335 105.963 52.894 105.963 52.894C107.936 48.8783 114.412 47.5741 117.404 47.424Z",
  fill: "#4D46FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2359 49.7984L83.9766 57.7177L87.2763 61.6775L89.9161 59.0377L98.4953 57.7177C99.8152 55.5179 102.455 50.8543 102.455 49.7984C102.455 48.4785 101.135 46.4987 99.8152 47.8186C98.7593 48.8745 97.6154 48.2585 97.1754 47.8186L91.2359 49.7984Z",
  fill: "#EC404A",
  stroke: "#FF9BFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5401 47.5133C99.5401 48.4502 95.9786 50.0748 95.1979 50.27L88.5 51.5L90 49.5L99.5 44C99.5 44.7807 99.5401 46.5765 99.5401 47.5133Z",
  fill: "#4D46FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.85567 37.9888C7.06651 37.7574 6.27015 37.2295 6.27015 36.164C6.27015 34.6207 4.59914 36.294 3.69955 37.3982C3.1456 36.8118 2.96995 36.0115 2.96995 35.5039C2.96995 35.5039 2.69875 34.0129 2 34C1.29268 33.9869 0.990116 35.5039 0.990116 35.5039C0.770135 38.5836 0.59415 45.0071 1.65006 46.063C2.70597 47.1189 7.36957 48.2628 9.56938 48.7028L11.5492 52.6624L15.5 49L14.8489 44.7431L10.2293 37.4837C9.8206 37.62 8.95622 37.8406 7.85567 37.9888Z",
  fill: "#EC404A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.85567 37.9888L7.71496 38.4686L7.81701 38.4985L7.92241 38.4844L7.85567 37.9888ZM3.69955 37.3982L3.33606 37.7416L3.72732 38.1558L4.0872 37.714L3.69955 37.3982ZM2.96995 35.5039H3.46995V35.4588L3.46188 35.4144L2.96995 35.5039ZM2 34L1.99074 34.4999L2 34ZM0.990116 35.5039L0.499774 35.4061L0.493626 35.4369L0.491387 35.4683L0.990116 35.5039ZM9.56938 48.7028L10.0166 48.4792L9.90724 48.2604L9.66744 48.2125L9.56938 48.7028ZM11.5492 52.6624L11.102 52.886L11.4002 53.4824L11.8891 53.0291L11.5492 52.6624ZM15.5 49L15.8399 49.3667L16.0343 49.1865L15.9943 48.9244L15.5 49ZM14.8489 44.7431L15.3432 44.6675L15.3273 44.5635L15.2708 44.4747L14.8489 44.7431ZM10.2293 37.4837L10.6512 37.2153L10.4416 36.8859L10.0712 37.0094L10.2293 37.4837ZM5.77015 36.164C5.77015 36.837 6.02753 37.3616 6.4156 37.7449C6.7917 38.1164 7.27225 38.3388 7.71496 38.4686L7.99638 37.509C7.64993 37.4074 7.33771 37.2501 7.11834 37.0335C6.91094 36.8286 6.77015 36.5565 6.77015 36.164H5.77015ZM4.0872 37.714C4.5317 37.1684 5.13702 36.5214 5.60489 36.2007C5.71864 36.1227 5.80645 36.0767 5.86756 36.054C5.93451 36.0293 5.92553 36.0486 5.87311 36.0354C5.7936 36.0154 5.75216 35.9583 5.74503 35.9433C5.74482 35.9429 5.75178 35.9578 5.75843 35.9964C5.76501 36.0345 5.77015 36.0892 5.77015 36.164H6.77015C6.77015 35.9357 6.7408 35.7088 6.64814 35.5139C6.54612 35.2994 6.3671 35.1285 6.11688 35.0656C5.89375 35.0095 5.68092 35.0568 5.52042 35.1162C5.35408 35.1778 5.19085 35.2721 5.0395 35.3759C4.44696 35.782 3.76699 36.5238 3.3119 37.0824L4.0872 37.714ZM4.06304 37.0549C3.62169 36.5876 3.46995 35.9254 3.46995 35.5039H2.46995C2.46995 36.0975 2.66952 37.0359 3.33606 37.7416L4.06304 37.0549ZM2.96995 35.5039C3.46188 35.4144 3.46185 35.4143 3.46183 35.4142C3.46182 35.4141 3.4618 35.414 3.46178 35.4139C3.46175 35.4137 3.46171 35.4135 3.46167 35.4133C3.46158 35.4128 3.46147 35.4122 3.46135 35.4116C3.46111 35.4103 3.4608 35.4086 3.46041 35.4066C3.45964 35.4025 3.4586 35.3971 3.45726 35.3903C3.45459 35.3768 3.45076 35.358 3.44574 35.3346C3.4357 35.288 3.42078 35.2228 3.40061 35.1451C3.36069 34.9913 3.2982 34.7808 3.20891 34.5654C3.12171 34.355 2.99746 34.1113 2.82291 33.9115C2.64761 33.7108 2.37741 33.5069 2.00926 33.5001L1.99074 34.4999C1.97196 34.4996 1.99769 34.4869 2.06977 34.5694C2.14259 34.6527 2.21715 34.7843 2.2851 34.9482C2.35095 35.1071 2.39994 35.2702 2.4327 35.3964C2.44887 35.4587 2.4606 35.5101 2.46812 35.545C2.47188 35.5625 2.47456 35.5757 2.4762 35.584C2.47702 35.5882 2.47758 35.5911 2.47788 35.5927C2.47804 35.5935 2.47812 35.5939 2.47814 35.5941C2.47816 35.5941 2.47815 35.5941 2.47813 35.594C2.47812 35.5939 2.4781 35.5939 2.47809 35.5938C2.47808 35.5937 2.47806 35.5936 2.47806 35.5936C2.47804 35.5935 2.47802 35.5934 2.96995 35.5039ZM2.00926 33.5001C1.63508 33.4932 1.35591 33.6932 1.17412 33.8928C0.993461 34.0912 0.863222 34.336 0.771223 34.5478C0.676951 34.7648 0.60987 34.9777 0.566657 35.1334C0.54482 35.212 0.528534 35.2781 0.517531 35.3253C0.51202 35.349 0.507807 35.3681 0.504863 35.3818C0.50339 35.3886 0.502232 35.3941 0.501385 35.3982C0.500962 35.4003 0.500617 35.4019 0.500348 35.4033C0.500214 35.4039 0.500099 35.4045 0.500003 35.405C0.499956 35.4052 0.499913 35.4054 0.499874 35.4056C0.499855 35.4057 0.49983 35.4058 0.499821 35.4059C0.499797 35.406 0.499774 35.4061 0.990116 35.5039C1.48046 35.6017 1.48044 35.6018 1.48042 35.6019C1.48041 35.6019 1.4804 35.602 1.48039 35.6021C1.48037 35.6022 1.48035 35.6022 1.48034 35.6023C1.48032 35.6024 1.48031 35.6024 1.48033 35.6024C1.48036 35.6022 1.48046 35.6017 1.48063 35.6009C1.48097 35.5993 1.4816 35.5963 1.48251 35.592C1.48434 35.5835 1.48732 35.57 1.49147 35.5522C1.49977 35.5165 1.51265 35.4641 1.53023 35.4008C1.56585 35.2725 1.61862 35.1069 1.6884 34.9463C1.76046 34.7804 1.83848 34.6485 1.91349 34.5661C1.98737 34.485 2.01126 34.5003 1.99074 34.4999L2.00926 33.5001ZM0.491387 35.4683C0.380622 37.019 0.280723 39.4123 0.341832 41.5566C0.372345 42.6274 0.443332 43.6502 0.576898 44.4802C0.643617 44.8948 0.727938 45.2742 0.835975 45.5929C0.940335 45.9009 1.08337 46.2034 1.29651 46.4166L2.00361 45.7095C1.95277 45.6586 1.87033 45.5295 1.78306 45.272C1.69948 45.0253 1.62603 44.7056 1.5642 44.3213C1.44066 43.5537 1.37141 42.5802 1.34143 41.5281C1.28155 39.4269 1.37963 37.0686 1.48885 35.5395L0.491387 35.4683ZM1.29651 46.4166C1.63457 46.7546 2.20383 47.0549 2.82858 47.3195C3.47182 47.5919 4.24146 47.8535 5.03678 48.0927C6.62843 48.5713 8.36022 48.9708 9.47133 49.1931L9.66744 48.2125C8.57874 47.9947 6.87882 47.6024 5.32474 47.1351C4.5472 46.9012 3.81546 46.6514 3.21855 46.3986C2.60316 46.138 2.1935 45.8993 2.00361 45.7095L1.29651 46.4166ZM9.12217 48.9264L11.102 52.886L11.9964 52.4388L10.0166 48.4792L9.12217 48.9264ZM11.8891 53.0291L15.8399 49.3667L15.1601 48.6333L11.2093 52.2958L11.8891 53.0291ZM15.9943 48.9244L15.3432 44.6675L14.3547 44.8187L15.0057 49.0756L15.9943 48.9244ZM15.2708 44.4747L10.6512 37.2153L9.8075 37.7522L14.4271 45.0116L15.2708 44.4747ZM10.0712 37.0094C9.69669 37.1342 8.86348 37.3486 7.78893 37.4933L7.92241 38.4844C9.04895 38.3326 9.94451 38.1057 10.3874 37.9581L10.0712 37.0094Z",
  fill: "#FF9BFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M79.357 209.069L68.5 209.5L70.1177 227.548L78.0371 226.228L79.357 209.069Z",
  fill: "#EC404A",
  stroke: "#4D46FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0024 231.507L24 207L34.5 212L21.9419 233.487L16.0024 231.507Z",
  fill: "#EC404A",
  stroke: "#4D46FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5011 38.8038C38.3086 32.4683 45.04 36.164 47.6798 38.8038C48.9997 41.2236 52.1674 45.6672 54.2792 44.0833C56.391 42.4995 59.9987 46.0632 61.5386 48.043C64.6183 52.8826 70.7778 63.2217 70.7778 65.8615C70.7778 68.5013 72.0977 68.2813 72.7576 67.8413C75.3974 64.1456 82.2168 58.8221 85.2966 56.6223L87.9363 61.2419C76.0574 78.4004 73.4176 83.02 69.4579 83.68C66.2902 84.2079 65.4983 82.1401 65.4983 81.0402L59.5588 92.9192C60.2187 95.339 61.1426 100.839 59.5588 103.478C57.9749 106.118 58.4589 107.218 58.8988 107.438C64.8383 108.758 77.3772 137.135 80.677 143.075C83.3167 147.826 83.9767 155.614 83.9767 158.914V209.069L65.4983 211.049C63.7384 203.57 59.9547 187.687 58.8988 183.991C57.5789 179.372 60.8787 163.533 61.5386 158.914C62.0666 155.218 56.479 146.375 53.6193 142.415C54.2792 147.035 55.7311 157.594 56.259 162.873C56.919 169.473 58.8988 175.412 53.6193 182.672C49.3956 188.479 39.9804 206.21 35.8008 214.349L19.3022 205.11C26.5616 176.072 36.4607 169.473 37.7806 165.513C38.8365 162.345 34.7009 156.714 32.5011 154.294C15.3425 134.496 13.3627 119.317 14.0227 107.438C14.5506 97.9347 26.0765 84.1199 31.7735 78.4004V71.141C27.2282 76.8995 22.3267 81.1225 19.3022 78.4004C14.0227 73.6488 10.9429 57.9422 10.063 50.6828C13.2307 51.2107 14.9026 49.5829 15.3425 48.703L23.2619 57.9422C23.9218 54.2025 26.6936 45.1393 32.5011 38.8038Z",
  fill: "#FF9BFF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M30.521 79.7202C36.4605 85.4397 50.5833 96.0868 59.5585 92.9191",
  stroke: "#EC404A",
  strokeWidth: 1.17112
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7982 46.7227C61.4068 47.7786 60.4389 40.4431 60.8789 37.1434L56.259 36.1636L52.2993 42.763C56.479 48.2625 65.7622 59.6576 69.4579 61.2414C74.0775 63.2213 76.0573 59.9216 76.7172 59.2616C77.2452 58.7337 77.8171 56.4018 78.0371 55.3019C82.2608 52.1342 81.1169 45.6228 80.017 42.763C79.3571 43.6429 76.1896 45.6668 68.7982 46.7227Z",
  fill: "#4D46FF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M71.4379 67.8413C69.0309 69.5606 67.4264 73.6127 66.4785 77.0805",
  stroke: "#EC404A",
  strokeWidth: 1.17112
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8408 71.1414C34.2606 68.0616 39.4962 60.5823 41.08 55.3027",
  stroke: "#EC404A",
  strokeWidth: 1.17112
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9591 73.1209C50.8473 73.6488 46.7997 72.021 45.0398 71.141L39.7603 69.1612C42.4 72.2409 48.7355 78.1364 52.9591 77.0805C57.1828 76.0246 59.9985 70.4811 60.8785 67.8413C59.1186 69.3812 55.0709 72.5929 52.9591 73.1209Z",
  fill: "#EC404A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M64.8384 23.625V14.3858C64.1784 13.7259 60.2186 15.7057 57.5788 17.6855C54.939 19.6653 54.939 17.6855 52.9592 19.0054C51.3753 20.0613 51.4193 23.845 51.6393 25.6048C50.9794 23.405 49.2637 19.7973 47.6798 22.9651C46.096 26.1328 48.7798 27.8047 50.3196 28.2446L48.9997 31.5443C50.3196 36.8239 60.8787 38.1438 62.1986 37.4838C63.2545 36.9559 63.0785 35.064 62.8586 34.1841C63.2985 34.1841 64.3104 34.0521 64.8384 33.5242C65.3663 32.9962 64.6184 32.4243 64.1784 32.2043L65.4983 30.8844C66.1583 30.2244 64.8384 28.2446 65.4983 28.2446C66.1583 28.2446 67.4782 27.5847 67.4782 26.2648C67.4782 25.2089 65.7183 24.065 64.8384 23.625Z",
  fill: "#EC404A"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9591 42.1037L56.2588 36.8241L49.6594 33.5244L45.6997 40.7838L57.5787 54.6426L52.9591 42.1037Z",
  fill: "#EC404A"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M43.0601 111.398L53.6192 143.075",
  stroke: "#4D46FF",
  strokeWidth: 1.17112
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3599 122.617C48.1197 122.397 52.0354 120.769 53.6192 116.017",
  stroke: "#4D46FF",
  strokeWidth: 1.17112
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M69.4582 16.3657C69.9862 20.0613 67.4784 22.9651 66.1585 23.625C64.8386 24.285 64.8386 22.9651 64.8386 22.9651V14.3859L64.1787 15.0458L56.9193 19.0055C56.4794 19.0055 53.6196 17.6856 52.9597 20.3253C52.2997 22.9651 51.4198 24.285 51.6398 25.6049C50.3199 22.3052 49.6599 21.6452 48.3401 22.3052C47.6801 22.9651 47.6801 23.3659 47.6801 23.6251C47.6801 27.5847 51.6398 27.5847 52.9597 31.5444C54.2795 35.5041 49.5074 40.3392 45.7003 37.4839C43.0605 35.5041 36.681 36.384 33.8213 37.4839C35.8011 30.2245 41.0807 13.8579 43.7204 9.10628C46.3602 4.35468 50.5399 4.92663 52.2997 5.80656C57.7992 7.78639 68.9303 12.67 69.4582 16.3657Z",
  fill: "#4D46FF"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5416 225.567L16.6626 219.628L10.7231 237.446V246.686L14.6828 247.346L15.3428 240.746C17.4546 240.218 20.6223 243.386 24.582 246.686C28.5416 249.985 38.4408 249.985 38.4408 249.985C24.582 242.726 25.8343 239.749 24.582 233.487C24.054 230.847 27.0018 227.107 28.5416 225.567Z",
  fill: "#4D46FF"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6772 220.948L67.4783 222.268L68.1382 249.325H72.0979V242.726C78.0374 242.726 76.7175 244.046 83.3169 247.346C89.9164 250.645 97.8357 249.985 97.8357 249.985C97.8357 249.985 90.8364 246.699 87.2766 243.386C84.1822 240.506 80.6772 234.807 80.6772 234.807V220.948Z",
  fill: "#4D46FF"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6826 112.057C16.0025 112.057 18.9063 111.793 19.9622 110.737C21.0181 109.681 23.0419 103.698 23.9218 100.838L19.9622 98.8584",
  stroke: "#EC404A",
  strokeWidth: 1.17112
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 78.6975,
  cy: 154.294,
  rx: 3.95966,
  ry: 7.91932,
  fill: "#4D46FF"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.8947,
  cy: 175.541,
  rx: 2.82009,
  ry: 6.50761,
  transform: "rotate(19.9981 51.8947 175.541)",
  fill: "#4D46FF"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2563 13.7176C37.0347 6.35184 47.2857 4.27329 52.564 4.15474C52.3292 3.49991 52.3816 1.91446 54.4692 0.811401C57.0787 -0.567428 57.0468 1.11839 56.4633 1.42672C55.1586 2.11617 54.5137 2.79074 54.5433 4.11029C59.6362 5.53616 69.5787 9.31752 68.6061 13.036C67.3903 17.6841 39.7833 22.9249 38.2563 13.7176Z",
  fill: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.4999,
  cy: 47.6547,
  rx: 1.53098,
  ry: 0.76549,
  transform: "rotate(-61.7557 99.4999 47.6547)",
  fill: "#FF9BFF"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 101.699,
  cy: 46.8446,
  rx: 1.53098,
  ry: 0.76549,
  transform: "rotate(-61.7557 101.699 46.8446)",
  fill: "#FF9BFF"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.74,
  cy: 48.9428,
  rx: 1.53098,
  ry: 0.76549,
  transform: "rotate(-61.7557 102.74 48.9428)",
  fill: "#FF9BFF"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 97.4306,
  cy: 49.1478,
  rx: 1.53098,
  ry: 0.76549,
  transform: "rotate(-61.7557 97.4306 49.1478)",
  fill: "#FF9BFF"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 49.187,
  cy: 27.5273,
  r: 2.34223,
  fill: "#FF9BFF"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M59.7271 22.8428C60.5078 23.4283 62.5377 24.2481 64.4115 22.8428",
  stroke: "black",
  strokeWidth: 1.17112
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6548 32.2121C63.8259 31.2361 66.1681 29.5185 66.1681 30.4554C66.1681 30.9005 65.8507 31.5917 65.2451 31.9957C65.4226 32.0349 65.5463 32.1033 65.5826 32.212C65.7778 32.7976 65.9339 33.9687 64.997 33.9687C64.0601 33.9687 63.0452 32.7976 62.6548 32.2121Z",
  fill: "#4D46FF"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.38645,
  cy: 38.8329,
  rx: 1.53098,
  ry: 0.76549,
  fill: "#FF9BFF"
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.22475,
  cy: 33.6973,
  rx: 1.53098,
  ry: 0.76549,
  transform: "rotate(-70.8788 1.22475 33.6973)",
  fill: "#FF9BFF"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.38645,
  cy: 41.1752,
  rx: 1.53098,
  ry: 0.76549,
  fill: "#FF9BFF"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.38645,
  cy: 43.5174,
  rx: 1.53098,
  ry: 0.76549,
  fill: "#FF9BFF"
});

function SvgReading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 251,
    viewBox: "0 0 126 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading);
export default __webpack_public_path__ + "static/media/reading.ae4c8962.svg";
export { ForwardRef as ReactComponent };